import React, { useState } from "react";
import AbhaNumberDetails from "../abhanumber-details/abhanumber-details";
import {
  AbhaViaSendAadharOtp,
  AbhaViaSendAbhaOtp,
  AlreadyAbhaNumberSearch,
  EncryptDataABDM,
  SearchUsingAbhaAddress,
  SendAadharOtp,
} from "../../services";
import VerifyNumberAbha from "../abhanumber-details/verify-number-abha";
import VerifyAbhaAddress from "./verify-abhaaddress";
import qrcode from "../../assets/image/qrcode.png";
import { useDispatch, useSelector } from "react-redux";
import { setResentCount } from "../../redux/slices/abhaSlice";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";

const AlreadyAbhaNumber = () => {
  const [inputType, setInputType] = useState("mobile");
  const [inputValue, setInputValue] = useState("");
  const [abhaNumberDetails, setAbhaNumberDetails] = useState(false);
  const [sendOtpResponse, setsendOtpResponse] = useState(false);
  const [otpType, setOtpType] = useState("");
  const [error, setError] = useState("");
  const [showQrModal, setShowQrModal] = useState(false);
  const [resMessage, setResMessage] = useState("");
  const [showAadhaar, setShowAadhaar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [abhaDetails, setAbhaDetails] = useState({
    name: "",
    number: "",
    txnId: "",
  });
  const resendCount = useSelector((state) => state.user.resentCount);
  const dispatch = useDispatch();

  const mobileNumberRegex = /^[0-9]{10}$/;
  const aadhaarNumberRegex = /^[0-9]{12}$/;
  const abhaNumberRegex = /^[0-9]{14}$/;
  const abhaAddressRegex = /^[a-zA-Z0-9._%+-]+@sbx$/;

  function formatNumber(inputValue) {
    let str = String(inputValue);
    return str.replace(/^(\d{2})(\d{4})(\d{4})(\d{4})$/, "$1-$2-$3-$4");
  }

  const processAbhaRequest = async () => {
    let response;

    if (inputType === "mobile") {
      response = await AlreadyAbhaNumberSearch({
        headers: {},
        data: { [inputType]: inputValue, otpType, resent_count: resendCount },
      });

      if (response.success !== true)
        toast.error(response?.message || "Search failed");

      const abha = response.data?.[0]?.ABHA;
      const txnId = response.data?.[0]?.txnId;

      if (response?.resent_count !== undefined) {
        dispatch(setResentCount(response.resent_count));
      }

      if (abha) {
        setAbhaDetails({
          name: abha.name,
          number: abha.ABHANumber,
          txnId: txnId,
        });
        localStorage.setItem(
          "abhaDetails",
          JSON.stringify({ abha, inputValue })
        );
        localStorage.setItem("inputValue", inputValue);
        localStorage.setItem("inputType", "mobile");
        localStorage.setItem("otpType", otpType);
        if (txnId) localStorage.setItem("txnId", txnId);
        setAbhaNumberDetails(true);
      }
    } else if (inputType === "aadhaar") {
      const encryptedInput = await EncryptDataABDM({ body: inputValue });
      const payload = {
        scope: ["abha-login", "aadhaar-verify"],
        loginHint: "aadhaar",
        loginId: encryptedInput.data,
        otpSystem: "aadhaar",
        resent_count: resendCount,
      };

      response = await SendAadharOtp({ headers: {}, data: payload });

      if (response?.resent_count !== undefined) {
        dispatch(setResentCount(response.resent_count));
      }

      if (response.success !== true) {
        let errorMessage = response?.error?.loginId || response?.message;
        if (response.error.loginId) {
          errorMessage = "Aadhaar number not registered";
        }

        if (errorMessage?.includes(":")) {
          const errorCode = errorMessage.split(":").pop().trim();
          toast.error(errorCode);
        } else {
          toast.error(errorMessage || "Failed to send OTP");
        }
      }
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        setResMessage(response?.message);
        setsendOtpResponse(true);
      }
    } else if (inputType === "abha") {
      const formattedValue = formatNumber(inputValue);
      const encryptedInput = await EncryptDataABDM({ body: formattedValue });

      if (otpType === "aadhaar") {
        response = await AbhaViaSendAadharOtp({
          headers: {},
          data: {
            scope: ["abha-login", "aadhaar-verify"],
            loginHint: "abha-number",
            loginId: encryptedInput.data,
            otpSystem: "aadhaar",
            resent_count: resendCount,
          },
        });
      } else if (otpType === "abdm") {
        response = await AbhaViaSendAbhaOtp({
          headers: {},
          data: {
            scope: ["abha-login", "mobile-verify"],
            loginHint: "abha-number",
            loginId: encryptedInput.data,
            otpSystem: "abdm",
            resent_count: resendCount,
          },
        });
      } else {
        toast.error("Please select an OTP method");
      }

      if (response?.resent_count !== undefined) {
        dispatch(setResentCount(response.resent_count));
      }

      if (response.success !== true) {
        toast.error(response?.message || "Failed to send OTP");
      }
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        setResMessage(response?.message);
        setsendOtpResponse(true);
      }
    } else if (inputType === "abhaaddress") {
      response = await SearchUsingAbhaAddress({
        headers: {},
        data: { abhaAddress: inputValue, resent_count: resendCount },
      });

      if (response?.resent_count !== undefined) {
        dispatch(setResentCount(response.resent_count));
      }

      if (response.success !== true) {
        toast.error(response?.message || "Failed to send OTP for ABHA Address");
      }
      const abha = response?.data;
      // const txnId = response?.data?.txnId;
      if (abha) {
        setAbhaDetails({
          name: abha.fullName,
          number: abha.healthIdNumber,
          abhaAddress: abha.healthIdNumber,
        });
        localStorage.setItem(
          "abhaDetails",
          JSON.stringify({ abha, inputValue })
        );
      }
      localStorage.setItem("inputType", "abhaaddress");
      localStorage.setItem("otpType", "abdm");
      localStorage.setItem("inputValue", inputValue);
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        setResMessage(response?.message);
        setsendOtpResponse(true);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = false;
    if (inputType === "mobile") {
      isValid = mobileNumberRegex.test(inputValue);
      if (!isValid)
        return setError("Please enter a valid 10-digit Mobile Number");
    } else if (inputType === "aadhaar") {
      isValid = aadhaarNumberRegex.test(inputValue);
      if (!isValid)
        return setError("Please enter a valid 12-digit Aadhaar Number");
    } else if (inputType === "abha") {
      const digitsOnly = String(inputValue).replace(/-/g, "");
      isValid = abhaNumberRegex.test(digitsOnly);
      if (!isValid)
        return setError("Please enter a valid 14-digit ABHA Number");
    } else if (inputType === "abhaaddress") {
      isValid = abhaAddressRegex.test(inputValue);
      if (!isValid) return setError("Please enter a valid ABHA Address");
    }

    if (!isValid) return;

    setError("");
    setLoading(true);

    try {
      await processAbhaRequest();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getHeading = () => {
    switch (inputType) {
      case "mobile":
        return "Enter your Mobile Number linked with ABHA";
      case "aadhaar":
        return "Enter your Aadhaar Number linked with ABHA";
      case "abha":
        return "Enter your ABHA Number";
      case "abhaaddress":
        return "Enter your ABHA Address";
      case "qrcode":
        return "Scan QR Code";
      default:
        return "";
    }
  };

  const handleBack = () => setAbhaNumberDetails(false);

  return (
    <>
      {inputType === "mobile" && abhaNumberDetails ? (
        <AbhaNumberDetails
          handleBack={handleBack}
          initialResentCount={resendCount}
          setServerResentCount={(count) => dispatch(setResentCount(count))}
          setResMessage={setResMessage}
          resMessage={resMessage}
        />
      ) : inputType === "mobile" && sendOtpResponse ? (
        <VerifyNumberAbha
          handleBack={() => setsendOtpResponse(false)}
          inputType="mobile"
          inputValue={inputValue}
          otpType="abdm"
          initialResentCount={resendCount}
          setServerResentCount={(count) => dispatch(setResentCount(count))}
          setResMessage={setResMessage}
          resMessage={resMessage}
        />
      ) : inputType === "aadhaar" && sendOtpResponse ? (
        <VerifyNumberAbha
          handleBack={() => setsendOtpResponse(false)}
          inputType="aadhaar"
          inputValue={inputValue}
          otpType="aadhaar"
          initialResentCount={resendCount}
          setServerResentCount={(count) => dispatch(setResentCount(count))}
          setResMessage={setResMessage}
          resMessage={resMessage}
        />
      ) : inputType === "abha" && sendOtpResponse ? (
        <VerifyNumberAbha
          handleBack={() => setsendOtpResponse(false)}
          inputType="abha"
          otpType={otpType}
          inputValue={inputValue}
          initialResentCount={resendCount}
          setServerResentCount={(count) => dispatch(setResentCount(count))}
          setResMessage={setResMessage}
          resMessage={resMessage}
        />
      ) : inputType === "abhaaddress" && sendOtpResponse ? (
        <VerifyAbhaAddress
          handleBack={() => setsendOtpResponse(false)}
          inputValue={inputValue}
          otpType={otpType}
          inputType="abha-address"
          initialResentCount={resendCount}
          setServerResentCount={(count) => dispatch(setResentCount(count))}
          setResMessage={setResMessage}
          resMessage={resMessage}
        />
      ) : (
        <div className="col-md-6">
          <div className="form-card content">
            <h3 className="custom-h3">{getHeading()}</h3>
            <div className="mb-3">
              <label>
                <input
                  type="radio"
                  value="mobile"
                  checked={inputType === "mobile"}
                  autoComplete="off"
                  onChange={() => {
                    setInputType("mobile");
                    setInputValue("");
                    setError("");
                  }}
                />{" "}
                Mobile
              </label>
              {"  "}
              <label className="mx-2">
                <input
                  type="radio"
                  value="aadhaar"
                  autoComplete="off"
                  checked={inputType === "aadhaar"}
                  onChange={() => {
                    setInputType("aadhaar");
                    setInputValue("");
                    setError("");
                  }}
                />{" "}
                Aadhaar
              </label>
              {"  "}
              <label className="mx-2">
                <input
                  type="radio"
                  value="abha"
                  autoComplete="off"
                  checked={inputType === "abha"}
                  onChange={() => {
                    setInputType("abha");
                    setInputValue("");
                    setError("");
                  }}
                />{" "}
                ABHA Number
              </label>
              <label className="mx-2">
                <input
                  type="radio"
                  value="abhaaddress"
                  autoComplete="off"
                  checked={inputType === "abhaaddress"}
                  onChange={() => {
                    setInputType("abhaaddress");
                    setInputValue("");
                    setError("");
                  }}
                />{" "}
                ABHA Address
              </label>
            </div>
            <form onSubmit={handleSubmit} className="pt-3">
              {/* <div className="aadhar-input d-flex justify-center pt-1">
                <input
                  className="adhar-input text-left"
                  type="text"
                  maxLength={
                    inputType === "mobile"
                      ? 10
                      : inputType === "aadhaar"
                      ? 12
                      : inputType === "abha"
                      ? 14
                      : 50
                  }
                  value={inputValue}
                  onChange={(e) =>
                    setInputValue(
                      inputType === "abha"
                        ? e.target.value.replace(/[^\d]/g, "").slice(0, 14)
                        : e.target.value.trim()
                    )
                  }
                  onKeyDown={(e) => {
                    if (
                      inputType !== "abhaaddress" &&
                      e.key !== "Backspace" &&
                      !(
                        e.key >= "0" &&
                        e.key <= "9" &&
                        e.key !== " " &&
                        e.key !== "." &&
                        e.key !== ","
                      )
                    ) {
                      return e.preventDefault();
                    }
                  }}
                  placeholder={
                    inputType === "mobile"
                      ? "Please enter Mobile Number"
                      : inputType === "aadhaar"
                      ? "Please enter Aadhaar Number"
                      : inputType === "abha"
                      ? "Please enter ABHA Number"
                      : "Please enter ABHA Address"
                  }
                  id="inputField"
                  required
                />
              </div> */}
              <div className="aadhar-input d-flex justify-center pt-1 position-relative">
                <input
                  className="adhar-input text-left pe-5"
                  type={
                    inputType === "aadhaar"
                      ? showAadhaar
                        ? "text"
                        : "password"
                      : "text"
                  }
                  autoComplete="off"
                  maxLength={
                    inputType === "mobile"
                      ? 10
                      : inputType === "aadhaar"
                      ? 12
                      : inputType === "abha"
                      ? 14
                      : 50
                  }
                  value={inputValue}
                  onChange={(e) =>
                    setInputValue(
                      inputType === "abha"
                        ? e.target.value.replace(/[^\d]/g, "").slice(0, 14)
                        : e.target.value.trim()
                    )
                  }
                  onKeyDown={(e) => {
                    if (
                      (e.ctrlKey || e.metaKey) &&
                      ["a", "c", "v", "x"].includes(e.key.toLowerCase())
                    ) {
                      return;
                    }

                    if (
                      inputType !== "abhaaddress" &&
                      e.key !== "Backspace" &&
                      !(
                        e.key >= "0" &&
                        e.key <= "9" &&
                        e.key !== " " &&
                        e.key !== "." &&
                        e.key !== ","
                      )
                    ) {
                      e.preventDefault();
                    }
                  }}
                  placeholder={
                    inputType === "mobile"
                      ? "Please enter Mobile Number"
                      : inputType === "aadhaar"
                      ? "Please enter Aadhaar Number"
                      : inputType === "abha"
                      ? "Please enter ABHA Number"
                      : "Please enter ABHA Address"
                  }
                  id="inputField"
                  required
                />

                {inputType === "aadhaar" && (
                  <span
                    className="position-absolute"
                    style={{
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowAadhaar((prev) => !prev)}
                  >
                    {showAadhaar ? (
                      <Eye className="eye-icon text-black mb-3" />
                    ) : (
                      <EyeOff className="eye-icon text-black mb-3" />
                    )}
                  </span>
                )}
              </div>

              {inputType === "abha" && (
                <div className="d-flex align-items-center gap-3 my-2">
                  <div>
                    <input
                      type="radio"
                      name="otpType"
                      value="abdm"
                      id="abdmOtp"
                      autoComplete="off"
                      className="mx-1"
                      onChange={(e) => setOtpType(e.target.value)}
                      checked={otpType === "abdm"}
                    />
                    <label htmlFor="abdmOtp">Mobile OTP</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="otpType"
                      value="aadhaar"
                      autoComplete="off"
                      id="aadhaarOtp"
                      className="mx-1"
                      onChange={(e) => setOtpType(e.target.value)}
                      checked={otpType === "aadhaar"}
                    />
                    <label htmlFor="aadhaarOtp">Aadhaar OTP</label>
                  </div>
                </div>
              )}

              {error && (
                <div className="text-danger pt-2" style={{ fontSize: "14px" }}>
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="continue-btn nha-adhar continue-btn custom-btnmargin"
                disabled={loading}
              >
                {loading ? "Linking..." : "Continue"}
              </button>
            </form>
            {inputType !== "aadhaar" && (
              <p className="text-center mt-3">
                Don't have a ABHA?{" "}
                <span
                  className="resend-message cursor-pointer"
                  onClick={() => {
                    dispatch(setGlobalCurrentStep("SendAdharOTP"));
                  }}
                >
                  Create New
                </span>
              </p>
            )}
            {/* <p className="text-center mt-3">
              Don't have a ABHA?{" "}
              <span
                className="resend-message cursor-pointer"
                onClick={() => {
                  dispatch(setGlobalCurrentStep("SendAdharOTP"));
                }}
              >
                Create New
              </span>
            </p> */}
          </div>
        </div>
      )}
      {showQrModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ maxWidth: "400px", width: "100%" }}
          >
            <div className="modal-content p-4 text-center">
              <h5 className="mb-3">Scan this QR Code</h5>
              <img
                src={qrcode}
                alt="QR Code"
                style={{ width: "100%", height: "auto", marginBottom: "20px" }}
              />
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowQrModal(false);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AlreadyAbhaNumber;
